export enum ApplicationStep {
  REGISTRATION = "REGISTRATION",
  PERSONAL_PROFILE = "PERSONAL_PROFILE",
  BANKING = "BANKING",
  CREDIT = "CREDIT",
  DOCUMENT = "DOCUMENT",
  MORTGAGE_INFORMATION = "MORTGAGE_INFORMATION",
}
